
//export const server = "http://localhost:8000/api/v2";
export const server = "https://ariariamarketplace-1.onrender.com/api/v2";


//export const backend_url = "http://localhost:8000/";
export const backend_url = "https://ariariamarketplace-1.onrender.com/";
